import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { Link } from 'react-router-dom';
//import useNavbarCall from '../hooks/useNavbarCall';
//import { useSelector } from 'react-redux';
import LogoPng from './LogoPng';

const drawerWidth = 240;

const pages = [
  {
    pageLink: "/",
    pageTitle: "HEM"
  },
  {
    pageLink: "/om-oss",
    pageTitle: "OM OSS"
  },{
    pageLink: "/aktiviteter",
    pageTitle: "AKTIVITETER"
  },{
    pageLink: "/kontakt",
    pageTitle: "KONTAKT"
  },
  {
    pageLink: "/kontakt/medlem",
    pageTitle: "BLI MEDLEM"
  },
  {
    pageLink: "/kalender",
    pageTitle: "KALENDER"
  },
]

function NavMenu(props) {

  //const {getPages, getLogo} = useNavbarCall();  
  //const {pages} = useSelector((state) => state.navbar);
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2}}>
        <LogoPng/>
      </Typography>
      <Divider />
      <List>
        {pages?.map((item) => (
          <ListItem key={item.pageTitle} disablePadding>
            <ListItemButton sx={{ textAlign: 'center', display:'flex', justifyContent:'center' }}>
              <Link to={item.pageLink} style={{"textDecoration":"none", "color":"#063a71"}} >
              <ListItemText primary={item.pageTitle}/>
              </Link>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav" sx={{backgroundColor: '#C62026'}}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon sx={{backgroundColor:'#C62026'}} />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            <LogoPng/>
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {pages?.map((item) => (
              <Link key={item.pageTitle} to={item.pageLink}>
              <Button sx={{ color: '#061A37', fontWeight:'700' }}>
                {item.pageTitle}
              </Button>
              </Link>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

NavMenu.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default NavMenu;